import React from "react";
import { Switch } from "@headlessui/react";

const Toggle = React.forwardRef(
  (
    { label, srLabel, checked, onChange, disabled = false, className = "" },
    ref
  ) => {
    // The switch's accessible name comes from its own sr-only child text (which
    // Headless UI renders inside the button). Prefer an explicit `srLabel` — for
    // callers that show the name in a visible column beside the switch and want
    // it announced there WITHOUT rendering the visible `<label>` below. Fall
    // back to the visible `label`, then a generic string.
    const accessibleName = srLabel || label || "Toggle setting";
    return (
      <div className={`flex items-center ${className}`}>
        <Switch
          ref={ref}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={`group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-ink-200 transition-colors duration-200 ease-editorial focus:outline-none focus:ring-2 focus:ring-accent-500/30 focus:ring-offset-2 data-[checked]:bg-accent-500 disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          <span className="sr-only">{accessibleName}</span>
          <span
            aria-hidden="true"
            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-editorial group-data-[checked]:translate-x-5"
          />
        </Switch>
        {label && (
          <label className="ml-3 block text-sm leading-6 text-ink-900">
            {label}
          </label>
        )}
      </div>
    );
  }
);

Toggle.displayName = "Toggle";

export default Toggle;
